// Single source of truth for the marketing FAQ. Rendered as visible content on
// the About page and emitted as FAQPage structured data (JSON-LD) for the same
// route via RouteSeo, so the schema always matches what's on the page.
export const FAQ_ITEMS = [
  {
    q: "What is the best personal training app for trainers?",
    a: "The best personal training app for trainers is one that is simple to use and covers the whole coaching workflow: program building, client workout tracking, check-ins, messaging, and payments. Trainer App combines all of these in one platform without the bloat, so you can onboard clients and deliver workouts in minutes.",
  },
  {
    q: "Can I use Trainer App for online coaching?",
    a: "Yes. Trainer App is built for online and hybrid coaching. You can program workouts remotely, track client progress, run check-ins, and collect payments from anywhere, while clients log their training from their phones.",
  },
  {
    q: "Is there a free trial for personal trainers?",
    a: "Yes. You can start a free trial and only pay as your coaching business grows. There is no long-term contract required to get started.",
  },
  {
    q: "Is Trainer App a personal trainer platform or a client app?",
    a: "Both. Trainer App is a complete personal trainer platform: coaches get personal trainer software to build programs, manage clients, and take payments, while clients get a simple personal training client app on their phone to view workouts and log every set. It works as an all-in-one trainer software for online and in-person coaching.",
  },
];
